import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { IRoutingControl, IRoute } from '../dto/RoutingControl';

@Module({ dynamic: true, store, name: 'routingControl', namespaced: true })
class RoutingControl extends VuexModule implements IRoutingControl {

    // state
    current: IRoute = { name: '', updateTime: new Date() };
    previous: IRoute = { name: '', updateTime: new Date() };
    moveState: string = '0';

    // getter
    /**
     * ストア内の前画面の画面名を取得する
     * @returns {name:previous.name}
     */
    get GET_PREVIOUS() {
        return {name: this.previous.name};
    }

    /**
     * ストア内の現在画面の画面名を取得する
     * @returns current.name
     */
    get GET_CURRENT() {
        return {name: this.current.name};
    }

    /**
     * 移動状態の確認
     * 画面間の移動があった場合trueを返す
     */
    get CHECK_MOVE_STATE(): boolean {
        let check = false;
        if (this.moveState === '0') {
            check = false;
        } else if (this.moveState === '1') {
            check = true;
        }
        return check;
    }

    // action
    /**
     * 遷移前の画面名をストアモジュールに登録する。
     * また、移動状態をtrueに変更。
     * @param preName 前画面の画面名
     */
    @Action({})
    public registPrevious(preName?: string) {
        if (preName !== undefined) {
            this.REGIST_PREVIOUS(preName);
        }
    }

    /**
     * 現在画面の画面名をストアモジュールに登録する。
     * また、移動状態をfalseに変更。
     * @param curName 現在画面の画面名
     */
    @Action({})
    public registCurrent(curName?: string) {
        if (curName !== undefined) {
            this.REGIST_CURRENT(curName);
        }
    }

    /**
     * 現在の画面から移動する際に、
     * currentに保存されている情報をpreviousに保存する
     */
    @Action({})
    public leaveCurrent() {
        this.LEAVE_CURRENT();
    }

    /**
     * モジュールのリセット
     */
    @Action({})
    public moduleReset() {
        this.MODULE_RESET();
    }

    // mutaions
    @Mutation
    private REGIST_PREVIOUS(preName: string) {
        this.previous.name = preName;
        this.previous.updateTime = new Date();
        this.moveState = '1';
    }

    @Mutation
    private REGIST_CURRENT(curName: string) {
        this.current.name = curName;
        this.current.updateTime = new Date();
    }

    @Mutation
    private LEAVE_CURRENT() {
        if (this.GET_CURRENT !== (undefined || null) && !this.CHECK_MOVE_STATE) {
            this.previous.name = this.current.name;
            this.previous.updateTime = new Date();
            this.moveState = '0';
        }
    }

    @Mutation
    private MODULE_RESET() {
        this.current = { name: '', updateTime: new Date() };
        this.previous = { name: '', updateTime: new Date() };
        this.moveState = '0';
    }
}

export const routingControlModule = getModule(RoutingControl);
